export default __webpack_public_path__ + "static/vexucopro-99e5489e6aa3e34ffa1e997005a82a6d.png";